import { useNode } from "@craftjs/core";
import * as React from "react";
import styled from "styled-components";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";

import ImageSettings from "./image-settings";

interface ImageProps {
  src: string;
  alt?: string;
  height?: string;
  width?: string;
  blockType?: string;
}

// TODO: rename, can't use `Image` as it's already resolved as the legacy image component
export default function ImageNew(props: ImageProps) {
  const {
    connectors: { connect },
  } = useNode();
  return (
    <StyledImage
      ref={connect}
      className="image-primitive"
      loading="lazy"
      {...props}
      alt={props.alt || ""}
      src={props.src}
    />
  );
}

const StyledImage = styled.img`
  width: 100%;
`;

ImageNew.craft = {
  custom: {
    displayName: "Image",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
    settings: ImageSettings,
  },
};
